<template>
    <div class="loading-spinner" :class="{ 'is-overlay' : isOverlay}"></div>
</template>

<script>
export default {
    props: {
        isOverlay: {
            type: Boolean,
            default: false
        }
    }
}
</script>